// extracted by mini-css-extract-plugin
module.exports = {"soldItem":"SoldItem_soldItem__2OXZZ"};